import request from 'superagent'
import {
    FLOWERAI_CLOUD_INTRO_QUESTIONS,
    FLOWERAI_CLOUD_SETTINGS,
    FLOWERAI_CLOUD_USER_PROFILE
} from '../constants/urls'

export const GET_INTRO_QUESTION_STATE = 'GET_INTRO_QUESTION_STATE'
export function getIntroQuestionsState(userId, token) {
    const req = request
        .get(FLOWERAI_CLOUD_INTRO_QUESTIONS.replace(':userId', userId))
        .query({
            token,
        })
        .auth('admin', 'supersecret')

    return {
        type: GET_INTRO_QUESTION_STATE,
        payload: req,
    }
}

export const SET_INTRO_QUESTION_STATE = 'SET_INTRO_QUESTION_STATE'
export function setIntroQuestionsState(userId, token, status) {
    const req = request
        .post(FLOWERAI_CLOUD_INTRO_QUESTIONS.replace(':userId', userId))
        .send({
            token,
            status,
        })
        .auth('admin', 'supersecret')

    return {
        type: SET_INTRO_QUESTION_STATE,
        payload: req,
    }
}

export const AUTH_USER_SET = 'AUTH_USER_SET'
export function setAuthUser(authUser) {
    return {
        type: AUTH_USER_SET,
        authUser,
    }
}

export const RESET_USER = 'RESET_USER'
export function resetUser() {
    return {
        type: RESET_USER,
        payload: null,
    }
}

export const GET_USER_SETTINGS = 'GET_USER_SETTINGS'
export function getUserSettings(userId, token) {
    const req = request
        .get(FLOWERAI_CLOUD_SETTINGS.replace(':userId', userId))
        .query({
            token,
        })
        .auth('admin', 'supersecret')

    return {
        type: GET_USER_SETTINGS,
        payload: req,
    }
}

export const SAVE_USER_SETTINGS = 'SAVE_USER_SETTINGS'
export function saveUserSettings(userId, token, settings) {
    const req = request
        .post(FLOWERAI_CLOUD_SETTINGS.replace(':userId', userId))
        .send({
            token,
            settings,
        })
        .auth('admin', 'supersecret')

    return {
        type: SAVE_USER_SETTINGS,
        payload: req,
    }
}

export const UPDATE_USER_IN_FIREBASE = 'UPDATE_USER_IN_FIREBASE'
export function updateUserInFirebase(user, displayName) {
    return {
        type: UPDATE_USER_IN_FIREBASE,
        payload: user.updateProfile({
            displayName,
        }),
    }
}

export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE'
export function updateUserProfile(userId, token, username, country, zipCode, gardenKnowledge) {
    const req = request
        .post(FLOWERAI_CLOUD_USER_PROFILE.replace(':userId', userId))
        .send({
            token,
            username,
            country,
            zipCode,
            gardenKnowledge,
        })
        .auth('admin', 'supersecret')

    return {
        type: UPDATE_USER_PROFILE,
        payload: req,
    }
}

export const GET_USER_PROFILE = 'UPDATE_USER_PROFILE'
export function getUserProfile(userId, token) {
    const req = request
        .get(FLOWERAI_CLOUD_USER_PROFILE.replace(':userId', userId))
        .query({ token })
        .auth('admin', 'supersecret')

    return {
        type: GET_USER_PROFILE,
        payload: req,
    }
}



// WEBPACK FOOTER //
// ./src/actions/users.js